import React from 'react';
import styled from 'styled-components';
import ThanxModal from '../../../components/thanx-modal';

const SuccessAlert = ({
  // data,
  thanxMessageTitle,
  thanxMessageSubTitle,
  thanxMessageFooterText,
}) => (
  <ThanxModal
    title={thanxMessageTitle}
    subTitle={thanxMessageSubTitle}
    footerText={thanxMessageFooterText}
  />
);

export default styled(SuccessAlert)``;
